import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './ShowAbout.css';
import { faFacebook, faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import aboutMe from '../../../images/ab-img.png';


const ShowAbout = () => {
    return (
        <section className="row justify-content-between align-items-center container-fluid">
            <div className="col-md-5">
                <img className="img-fluid" src={aboutMe} alt="about me"/>
            </div>
            <div className="col-12 col-md-6 a_detail">
                <div className="am_title mb-5">
                    <h1>About Me</h1>
                    <span className="g_touch">who i am</span>
                </div>
                <h5 className="as_title">Hello, I'm Riaz, MERN Stack web developer with industry experience building websites and web applications. Also i have good at </h5>
                <ul className="list-inline">
                    <li className="list-inline-item">
                        <span>React</span>
                    </li>
                    <li className="list-inline-item">
                        <span>JavaScript</span>
                    </li>
                    <li className="list-inline-item">
                        <span>NodeJs</span>
                    </li>
                    <li className="list-inline-item">
                        <span>MongoDB</span>
                    </li>
                    <li className="list-inline-item">
                        <span>HTML</span>
                    </li>
                    <li className="list-inline-item">
                        <span>CSS</span>
                    </li>
                    <li className="list-inline-item">
                        <span>Bootstrap</span>
                    </li>
                    <li className="list-inline-item">
                        <span>JQuery</span>
                    </li>
                    <li className="list-inline-item">
                        <span>Github</span>
                    </li>
                    <li className="list-inline-item">
                        <span>Shopify</span>
                    </li>
                </ul>
                
                <div className="social-link my-2">
                    <a target="blank" href="https://www.linkedin.com/in/monsurriaz/"><FontAwesomeIcon className="brand-link" icon={faLinkedin} /></a>
                    <a target="blank" href="https://github.com/monsurriaz"><FontAwesomeIcon className="brand-link" icon={faGithub} /></a>
                    <a target="blank" href="https://facebook.com/monsur.riaz"><FontAwesomeIcon className="brand-link" icon={faFacebook} /></a>
                </div>
                <button className="mt-3"><a className="btn" href="https://drive.google.com/u/6/uc?id=1Q7qjwPt6ec9gTh6pTdVnyJjcmp4F1ZuZ&export=download" target="blank">Download Resume</a></button>
            </div>
        </section>
    );
};

export default ShowAbout;